import React from 'react';
import Animated from 'react-native-reanimated';
import {NativeSyntheticEvent, StyleProp, TextInputSubmitEditingEventData, TextStyle, ViewStyle} from 'react-native';
import {WrappedFieldInputProps, WrappedFieldMetaProps, GenericFieldHTMLAttributes} from 'redux-form';
import {BaseFieldText} from './components/text';
import {BaseFieldCheckbox} from './components/checkbox';
import {BaseFieldRadio} from './components/radio';
import {BaseFieldDate} from './components/date';
import {BaseFieldSelect} from './components/select';
import {DictionaryItem} from '../../dictionaries/model';
import {BaseFieldSelectOwnProps} from './components/select/model';
import {BaseFieldColorScheme, DEFAULT_BASE_FIELD_COLOR_SCHEME} from './model';

export enum InputMaskTypes {
  tel = '8 999 999 99 99',
  card = '9999 9999 9999 9999',
  snils = '999-999-999 99',
}

export type BaseFieldVariant = 'standard' | 'outlined';

export type BaseFieldProps = {
  testIDprefix?: string;
  input: Partial<WrappedFieldInputProps>;
  meta?: WrappedFieldMetaProps;
  label?: string;
  mask?: string;
  type: 'text' | 'number' | 'phone' | 'hidden' | 'password' | 'checkbox' | 'radio' | 'digits' | 'date' | 'select';
  // | 'checkbox';
  values?: DictionaryItem[];
  // defaultDate?: Date;
  variant?: BaseFieldVariant;
  colorScheme?: BaseFieldColorScheme;
  multiline?: boolean;
  rowsMax?: number;
  rows?: number;
  maxLength?: number;
  autoFocus?: boolean;
  hint?: string;
  halfWidth?: boolean;
  // sort?: (a: DictionaryItem, b: DictionaryItem) => number;
  autoCapitalize: 'words' | 'none' | 'sentences' | 'characters';
  customStyles?: object;
  dotStyle?: ViewStyle;
  readOnly?: boolean;
  smallHeight?: boolean;
  disableErrorIcon?: boolean;
  right?: JSX.Element;
  rightStyle?: Animated.AnimateStyle<ViewStyle>;
  left?: JSX.Element;
  leftStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  inputContainerStyle?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  onCustomBlur(event: any, formName?: string, fieldName?: string, newValue?: any): Promise<void> | void;
  onSubmitEditing?: (event: NativeSyntheticEvent<TextInputSubmitEditingEventData>) => void;
  // Works only for BaseFieldText
  baseColor?: string;
} & GenericFieldHTMLAttributes &
  BaseFieldSelectOwnProps;

// @ts-ignore
export const BaseField: React.FC<BaseFieldProps> = (ownProps) => {
  const props: BaseFieldProps = {
    ...ownProps,
    variant: ownProps.variant || 'standard',
    colorScheme: ownProps.colorScheme || DEFAULT_BASE_FIELD_COLOR_SCHEME,
  };

  switch (props.type) {
    case 'number':
    case 'text':
    case 'phone':
    case 'hidden':
    case 'password':
    case 'digits':
      return BaseFieldText(props);
    case 'checkbox':
      return BaseFieldCheckbox(props);
    case 'radio':
      return BaseFieldRadio(props);
    case 'date':
      return BaseFieldDate(props);
    case 'select':
      return BaseFieldSelect(props);
  }
};

export const BaseFieldWrapper = (props: BaseFieldProps) => {
  return (
    <BaseField
      {...{
        ...props,
        input: {
          ...props.input,
          value: props.type === 'checkbox' ? !!props.input.value : props.input.value,
        },
      }}
    />
  );
};
